import React, { Component } from "react";
import "../../styles/den.css";
//npm packages
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import InfiniteScroll from "react-infinite-scroll-component";
// Images
import awardIc from "../../images/icon/den-award-ic.png";
import locationRight from "../../images/icon/location-right.png";
// Icons
import { AiOutlineSearch } from "react-icons/ai";
//components
import DenCommonTabs from "../Den/userDenSection/common/DenCommonTabs";
import LeftSideBar from "../Den/userDenSection/common/LeftSideBar";
import LeftSideBarUnRegistered from "../Den/userDenSection/common/LeftSideBarUnRegistered";
import PostCard from "../Den/userDenSection/common/PostCard";
import ReportPost from "../Den/userDenSection/common/ReportPost";
import RightSideBar from "../Den/userDenSection/common/RightSideBar";
import PostActions from "../popup/den/PostActions";
//utils
import {
  denLiveStreamSearch,
  getDenProfiles2,
  getFeedTvPosts,
  getPostInteractionsDetails,
  reportDenPost,
} from "../../utils/Den.utils";
import { GIF } from "../../utils/Images.utils";
import { profile } from "../../utils/localstorage.utils";
import PublicPostCard from "../Den/userDenSection/common/PublicPostCard";
import { getDetailsObj, isValidString } from "../../utils/common.utils";
import UndoReportPost from "../common/UndoReportPost";

export default class DenTV extends Component {
  constructor(props) {
    super(props);
    this.state = {
      openPostActionModal: false,
      openPostReportModal: false,
      selectedPostIndex: null,
      showWelcomePopup: true,
      feedDetails: [],
      showMoreNotificationIndex: null,
      selectedActionIndex: null,
      selectedReportType: null,
      selectedReportTypeDescription: null,
      activeTab: "HOME",
      denProfile: null,
      isSparked: false,
      postToInteract: null,
      openSpotlightForPostIndex: null,
      searchString: "",
      openMobileSubTabs: false,
      isSpinned: true,
      pageNo: 0,
      hasMorePosts: true,
      reportedDetails: null,
      detailsObj: null,
    };
    //this.componentRef=[];
  }

  componentDidMount() {
    this.props.showOrHideNav(true);
    if (this.props.match.params.denId && this.props.match.params.denId !== "undefined") {
      //console.log("DEN/ID : ", this.props.match.params.denId)
      getDenProfiles2({ profiles: [this.props.match.params.denId] }, this.setCurrentUserDenProfile);
    } else {
      this.fetchMorePosts();
    }
  }

  setCurrentUserDenProfile = result => {
    if (result && result[0]) {
      console.log("\n\n\n\n INSIDE IF : result :: ", result);
      this.setState({
        denProfile: result[0],
        isSparked: result[0].isSparked,
      });
      this.fetchMorePosts();
    } else {
      this.fetchMorePosts();
    }
    getDetailsObj(result[0], this.setDetailsObj);
  };

  setDetailsObj = res => {
    if (res) {
      this.setState({ detailsObj: res });
    }
  };

  updateState = (key, val) => {
    this.setState({
      [key]: val,
    });
  };

  showHidePostAction = (index, val1, val2) => {
    if (!val1 && !val2) {
      this.setState({
        selectedActionIndex: null,
        selectedReportType: null,
        selectedReportTypeDescription: null,
        openPostActionModal: val1,
        openPostReportModal: val2,
      });
    } else {
      this.setState({
        selectedActionIndex: index,
        openPostActionModal: val1,
        openPostReportModal: val2,
      });
    }
  };

  toggleWelcomePopup = val => {
    this.setState({ showWelcomePopup: val });
  };

  onCheckReportType = value => {
    this.setState({
      selectedReportType: this.state.selectedReportType === value ? null : value,
    });
  };

  onChangeReportDescription = val => {
    this.setState({
      selectedReportTypeDescription: val,
    });
  };

  onSubmitReport = () => {
    reportDenPost(
      this.state.feedDetails[this.state.selectedActionIndex]._id,
      {
        type: this.state.selectedReportType,
        description: this.state.selectedReportTypeDescription,
      },
      this.showHidePostAction,
      this.enableUndoReport
    );
  };

  enableUndoReport = report => {
    console.log(report);
    this.setState({
      reportedDetails: report,
    });
    setTimeout(() => {
      this.clearUndoReportPopup();
    }, 10000);
  };

  clearUndoReportPopup = () => {
    this.setState({
      reportedDetails: null,
    });
  };

  updateProfileDetails = updatedProfileDetails => {
    this.showHidePostAction(null, false, false);
    //updateDenProfileInLocalStorage(updatedProfileDetails);
    this.setState({
      denProfile: updatedProfileDetails,
    });
  };

  updatePostDetails = (result, selectedActionIndex, message) => {
    if (message) {
      toast.success(message);
    }
    const updatedPostDetails = this.state.feedDetails.map((post, i) => {
      if (post._id === result._id) {
        result.from = this.state.feedDetails[i].from;
        return result;
      } else {
        return post;
      }
    });
    console.log("");
    this.setState({
      feedDetails: updatedPostDetails,
    });
    this.showHidePostAction(null, false, false);
  };

  postToInteract = index => {
    this.setState({
      postToInteract: index,
    });
  };

  isSpinnedToday = (date1, date2) => {
    date1.setHours(0, 0, 0, 0);
    date2.setHours(0, 0, 0, 0);
    return date1.toString() === date2.toString();
  };

  fetchMorePosts = () => {
    console.log("\n\n\n\n\n\n Inside fetchMorePosts().......");
    var searchString = `pageNo=${this.state.pageNo}&limit=12&searchTerm=${this.state.searchString}`;
    denLiveStreamSearch(
      this.state.denProfile ? this.state.denProfile._id : profile().id,
      searchString,
      this.setFeedPosts
    );
  };

  setFeedPosts = newPosts => {
    if (newPosts.length > 0) {
      this.setState({
        feedDetails: this.state.feedDetails.concat(newPosts),
        pageNo: this.state.pageNo + 1,
      });
    } else {
      this.setState({
        hasMorePosts: false,
      });
    }
  };

  getDenFeed = () => {
    var isRoportingEnabled = this.state.selectedReportType !== null;

    return (
      <div className="col-12 col-lg-6">
        <div className="d-flex flex-column">
          <div className="d-flex mb-2">
            <div className="purple-field d-flex align-items-center border-0 height-45 flex-grow-1">
              <input
                type="search"
                placeholder="search"
                className="flex-grow-1 border-0 ps-3 text-white fs-14"
                style={{ background: "transparent", outline: "none" }}
                onChange={e => this.updateSearch(e)}
                value={this.state.searchString}
              />
              <AiOutlineSearch className="btn-size-20 me-2" />
            </div>
            <div
              className="violet_blue-gradient height-45 float-end d-flex justify-content-center align-items-center d-block d-lg-none ms-2"
              style={{ width: "45px" }}
            >
              <img src={awardIc} className="btn-size-25" alt="" />
            </div>
          </div>

          {/* Posts on feed */}
          <div className="row">
            <InfiniteScroll
              dataLength={this.state.feedDetails.length}
              next={this.fetchMorePosts}
              hasMore={this.state.hasMorePosts}
              loader={
                <div className="text-center">
                  <img
                    src={GIF.POST_LOAD}
                    alt=""
                    style={{ height: "75px", width: "-webkit-fill-available" }}
                  />
                </div>
              }
            >
              {this.state.feedDetails.map((post, i) => {
                var likes = 0;
                var likedUsers = [];
                Object.keys(post.likes).map((key, i) => {
                  likes += post.likes[key].length;
                  likedUsers = likedUsers.concat(post.likes[key]);
                });

                const interactions = getPostInteractionsDetails(
                  i,
                  post,
                  likedUsers,
                  this.state.denProfile,
                  this.state.postToInteract,
                  this.state.openSpotlightForPostIndex
                );
                const isPrivatePost =
                  !post.from[0]?.isPublic &&
                  !post.from[0]?.followers?.includes(this.state.denProfile?._id);

                return (
                  <div>
                    <PostCard
                      key={i}
                      i={i}
                      post={post}
                      isPrivatePost={isPrivatePost}
                      denProfile={this.state.denProfile}
                      postType={null}
                      interactions={interactions}
                      feedDetails={this.state.feedDetails}
                      selectedPostIndex={this.state.selectedPostIndex}
                      selectedReportType={this.state.selectedReportType}
                      showMoreNotificationIndex={this.state.showMoreNotificationIndex}
                      postToInteract={this.state.postToInteract}
                      showHidePostAction={this.showHidePostAction}
                      updateProfileDetails={this.updateProfileDetails}
                      updatePostDetails={this.updatePostDetails}
                      history={this.props.history}
                      isLiveStraming={true}
                      checkDenStatus={this.checkDenStatus}
                    />
                    {this.state.reportedDetails &&
                      this.state.reportedDetails?.postId === post._id && (
                        <UndoReportPost
                          updateState={this.updateState}
                          reportedDetails={this.state.reportedDetails}
                          clearUndoReportPopup={this.clearUndoReportPopup}
                        />
                      )}
                  </div>
                );
              })}
            </InfiniteScroll>
          </div>
        </div>

        <DenCommonTabs
          show={this.state.openMobileSubTabs}
          updateState={this.updateState}
          denProfile={this.state.denProfile}
        />

        {/* Post Action Div */}
        <PostActions
          postType={null}
          show={this.state.openPostActionModal}
          denProfile={this.state.denProfile}
          feedDetails={this.state.feedDetails}
          updatePostDetails={this.updatePostDetails}
          updateProfileDetails={this.updateProfileDetails}
          selectedActionIndex={this.state.selectedActionIndex}
          showHidePostAction={this.showHidePostAction}
          onClose={() => this.showHidePostAction(null, false, false)}
        />

        {/* Report Post Details */}
        <ReportPost
          onSubmitReport={this.onSubmitReport}
          showHidePostAction={this.showHidePostAction}
          onChangeReportDescription={this.onChangeReportDescription}
          onCheckReportType={this.onCheckReportType}
          isRoportingEnabled={isRoportingEnabled}
          openPostReportModal={this.state.openPostReportModal}
          selectedReportType={this.state.selectedReportType}
          selectedReportTypeDescription={this.state.selectedReportTypeDescription}
        />
      </div>
    );
  };

  nonDenUserFeed = () => {
    var isRoportingEnabled =
      this.state.selectedReportType !== null &&
      this.state.selectedReportTypeDescription?.length > 0;
    return (
      <div className="col-12 col-lg-6">
        <div className="d-flex flex-column" style={{ height: "90vh", overflow: "auto" }}>
          {/* Nav on users feed */}
          <NavLink
            to="/den-profile"
            className="gold_magenta-gradient border-0 d-flex justify-content-center align-items-center my-2"
          >
            <span className="fs-16 fw-500 py-2 px-3 text-white">Complete profile to use Den</span>
            <img src={locationRight} className="btn-size-15 ms-2" alt="" />
          </NavLink>

          {/* Posts on feed */}
          <div className="row my-3">
            {this.state.feedDetails.map((post, i) => {
              var likes = 0;
              var likedUsers = [];
              Object.keys(post.likes).map((key, i) => {
                likes += post.likes[key].length;
                likedUsers = likedUsers.concat(post.likes[key]);
              });

              const interactions = getPostInteractionsDetails(
                i,
                post,
                likedUsers,
                this.state.denProfile,
                this.state.postToInteract,
                this.state.openSpotlightForPostIndex
              );
              const isPrivatePost =
                !post.from[0]?.isPublic &&
                !post.from[0]?.followers?.includes(this.state.denProfile?._id);
              return (
                <PublicPostCard
                  key={i}
                  i={i}
                  post={post}
                  isPrivatePost={isPrivatePost}
                  postType={null}
                  denProfile={this.state.denProfile}
                  interactions={interactions}
                  history={this.props.history}
                  feedDetails={this.state.feedDetails}
                  selectedPostIndex={this.state.selectedPostIndex}
                  selectedReportType={this.state.selectedReportType}
                  showMoreNotificationIndex={this.state.showMoreNotificationIndex}
                  postToInteract={this.state.postToInteract}
                  showHidePostAction={this.showHidePostAction}
                  updateProfileDetails={this.updateProfileDetails}
                  updatePostDetails={this.updatePostDetails}
                  isLiveStraming={true}
                  checkDenStatus={this.checkDenStatus}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  };

  updateSearch = e => {
    if (!e.target.value.includes("#")) {
      var updatedSearchString = e.target.value;
      this.updateState("searchString", updatedSearchString);

      if (updatedSearchString?.trim().length > 2 && isValidString(updatedSearchString)) {
        console.log("\n\n\n\n\n\n Inside IF().......", updatedSearchString);
        var searchString;
        if (updatedSearchString?.trim().length === 3) {
          searchString = `pageNo=0&limit=12&searchTerm=${updatedSearchString}`;
          this.updateState("pageNo", 0);
        } else {
          searchString = `pageNo=${this.state.pageNo}&limit=12&searchTerm=${updatedSearchString}`;
        }

        denLiveStreamSearch(
          this.state.denProfile ? this.state.denProfile._id : profile().id,
          searchString,
          result => {
            this.updateState("feedDetails", result);
          }
        );
      } else {
        console.log("\n\n\n\n\n\n Inside Else().......", updatedSearchString?.trim().length);
        var searchString = `pageNo=0&limit=12`;
        denLiveStreamSearch(
          this.state.denProfile ? this.state.denProfile._id : profile().id,
          searchString,
          result => {
            this.updateState("feedDetails", result);
            this.updateState("pageNo", 0);
          }
        );
      }
    }
  };

  checkDenStatus = () => {
    if (!this.state.denProfile.isActive) {
      toast.error("Please re-activate your den profile to perform any action");
      return false;
    }
    return true;
  };

  render() {
    //console.log("### DEN/PROFILE :: ",this.state.denProfile)
    return (
      <div className="body-section den_page" style={{ height: "auto" }}>
        <div className="container p-3">
          <div className="row">
            {
              this.state.denProfile ? (
                <LeftSideBar
                  history={this.props.history}
                  activeTab={this.state.activeTab}
                  updateActiveTab={this.updateActiveTab}
                  denProfile={this.state.denProfile}
                  detailsObj={this.state.detailsObj}
                />
              ) : (
                <LeftSideBarUnRegistered profile={profile()} />
              ) // UnAuth User Den Side Panel
            }
            {this.state.denProfile ? this.getDenFeed() : this.nonDenUserFeed()}
            <RightSideBar
              denId={this.props.match.params.denId}
              activeTab={this.state.activeTab}
              updateActiveTab={this.updateActiveTab}
              denProfile={this.state.denProfile}
            />
          </div>
        </div>
      </div>
    );
  }
}
